<xemex-card [title]="'installations.alarmSettings.title' | translate">
  <div class="flex flex-col gap-4">
    <p class="m-0 text-sm text-text-secondary">
      {{ 'installations.alarmSettings.description' | translate }}
    </p>
    <p class="m-0 text-sm text-text-secondary" data-testid="alarm-settings-unavailable">
      {{ 'installations.alarmSettings.notAvailable' | translate }}
    </p>
    <xemex-table [data]="rows()" [columns]="columns" [pageable]="false" [compact]="true" />
  </div>
</xemex-card>
